export const isUsableUserChannelName = (channelName: string | null | undefined): channelName is string => {
  return typeof channelName === "string" && channelName.trim().length > 0 && !channelName.includes("undefined");
};
